module.exports = __webpack_public_path__ + "img/BA.70160bba.png";